const form = {
  validation: {
    salutation: {
      empty: 'Please select a salutation',
    },
    firstName: {
      empty: 'First name cannot be empty',
      format: {
        lettersOnly: 'Numbers and special characters are not allowed',
      },
    },
    lastName: {
      empty: 'Last name cannot be empty',
      format: {
        lettersOnly: 'Numbers and special characters are not allowed',
      },
    },
    phoneCountryCode: {
      empty: 'Please select a country code',
    },
    phone: {
      empty: 'Phone number cannot be empty.',
      min: 'The phone number is too short.',
      min2: 'The phone number is too short. Please check your entry.',
      max: 'The maximum number of characters has been exceeded. Please enter a phone number with a maximum of 20 characters.',
      format: {
        numbersOnly: 'Only numbers are allowed.',
      },
    },
    mobileCountryCode: {
      empty: 'Please select a country code',
    },
    mobile: {
      empty: 'Mobile number cannot be empty.',
      min: 'The mobile number is too short.',
      min2: 'The mobile number is too short. Please check your entry.',
      max: 'The maximum number of characters has been exceeded. Please enter a mobile number with a maximum of 20 characters.',
      format: {
        numbersOnly: 'Only numbers are allowed.',
      },
    },
    email: {
      empty: 'Email address cannot be empty.',
      format: 'This is not a valid email address. Please check your entry.',
    },
    message: {
      empty: 'Your message cannot be empty.',
    },
    password: {
      min: 'The password must be at least 8 characters long.',
      empty: 'Password cannot be empty.',
      error: 'The password must meet all requirements.',
    },
    policy: {
      bothNotAccepted: 'Please accept our Terms of Use and Privacy Policy.',
      termsOfUseNotAccepted: 'Please accept our Terms of Use.',
      privacyPolicyNotAccepted: 'Please accept our Privacy Policy.',
      consentNotAccepted: 'Please accept the forwarding of your order data to the pharmacy.',
    },
    street: {
      empty: 'Street cannot be empty',
    },
    houseNumber: {
      empty: 'House number cannot be empty',
      format: {
        numberRequired: 'Please enter a number',
        invalidOrder: 'Please enter the house number first, followed by the letter. The house number must consist of at least one number.',
        specialCharacters: 'This special character is invalid',
      },
    },
    zipCode: {
      empty: 'ZIP code cannot be empty',
      format: {
        numbersOnly: 'Only numbers are allowed.',
        length: 'ZIP code must consist of 5 numbers',
      },
    },
    city: {
      tooShort: 'The city name must contain at least 2 letters',
      tooLong: 'The city name is too long',
      symbolNotAllowed: 'This special character is not allowed',
      atLeastTwoLetters: 'Please enter at least 2 letters',
    },
  },
  password: {
    tags: {
      min8char: '8 characters',
      capChar: 'Uppercase letter',
      lowChar: 'Lowercase letter',
      numberChar: 'Number',
      specChar: 'Special character',
    },
  },
}

export default form
